export default __webpack_public_path__ + "static/media/screen1.6505cfd2.png";